import React, { forwardRef, useImperativeHandle, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

// hooks
import useTab from "hooks/useTab";
import { useLanguage } from "lang/Translate";

// common components
import Tooltip from "components/common/tooltip/Tooltip";

// assets
import tabs from "assets/json/tabs.json";

//css
import "./Sidebar.scoped.scss";

const Sidebar = forwardRef(({ navEnabled }, ref) => {
	const currentSidebarTab = useTab("") || null;
	const windowOpen = useSelector(state => state.window.open);
	const dispatch = useDispatch();
	const currLang = useLanguage();
	const __THEME__ = process.env.__THEME__;

	const toggleTab = useCallback(
		newAddress => {
			if (newAddress === currentSidebarTab) {
				dispatch({ type: "SET_WINDOW_ADDRESS", state: "" });
				return;
			}

			dispatch({ type: "SET_WINDOW_ADDRESS", state: newAddress });
		},
		[currentSidebarTab, dispatch]
	);

	useImperativeHandle(ref, () => ({ toggleTab }));
	return (
		<div className={navEnabled ? `sidebar ${__THEME__ === "retro" && "retro"}` : "sidebar hidden"}>
			{tabs.map(({ id, name, iconClass }) => (
				<Tooltip
					text={name[currLang === "PL" ? 0 : 1]}
					position={windowOpen ? "right" : "left"}
					compact={true}
					onMobile={false}
					key={id}
				>
					<i
						className={`${iconClass} icon ${currentSidebarTab === id && "icon--active"}`}
						onClick={() => toggleTab(id)}
					/>
				</Tooltip>
			))}
		</div>
	);
});

export default Sidebar;
